import { Component, NgZone, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Http } from '@angular/http';

@Component({
  selector: 'app-pending-purchase',
  templateUrl: './pending-purchase.component.html',
  styleUrls: ['./pending-purchase.component.css']
})
export class PendingPurchaseComponent implements OnInit {
  mainLoader;
  user_id;
  pendingPurchase;
  pendingLength;
  loading = false;
  pageSize= 9;
  pageNo =1;

  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private http: Http) {


      if (localStorage.getItem('currentUser')) {
        const userInfo = JSON.parse(localStorage.getItem('currentUser'));
        this.user_id = userInfo.result.id;
      }
     }

  ngOnInit() {
    this.mainLoader = '../../assets/images/BigLoader.gif';
    this.pendingBid();

  }

  public pendingBid() {
    this.loading = true;
    var params = {
      buyer_id: this.user_id,
      limit:this.pageSize,
      offset: 0
    };
      this.advtService.pendingPurchase(params).subscribe((data) => {
        this.pendingPurchase = data.result;
        this.pendingLength = data.count;
        this.loading = false;
      });
    }


    /**
* This function is used for pagination
* @param data
*/
pagingAgent(data, user_id) {
  this.loading = true;
  this.pendingPurchase = [];
  this.pageNo = (data * this.pageSize) - this.pageSize;
  var params = {
    buyer_id: this.user_id,
    limit:this.pageSize,
    offset: this.pageNo
  };
  this.pendingPurchase = [];
  this.advtService.pendingPurchase(params).subscribe((data) => {
      this.pendingPurchase = data.result;
      this.loading = false;

    });
}

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/pending-purchase/pending-purchase.component.ts